import { SvgIcon } from '@mui/material';
import FireExtinguisherIcon from '@mui/icons-material/FireExtinguisher';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import Battery5BarIcon from '@mui/icons-material/Battery5Bar';
import BlindIcon from '@mui/icons-material/Blind';
import AssistWalkIcon from '@mui/icons-material/AssistWalker';
import ComputerIcon from '@mui/icons-material/Computer';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import TabletMacIcon from '@mui/icons-material/TabletMac';
import SmartScreenIcon from '@mui/icons-material/SmartScreen';
import RouterIcon from '@mui/icons-material/Router';
import CribIcon from '@mui/icons-material/Crib';
import CoffeeMakerIcon from '@mui/icons-material/CoffeeMaker';
import DiningIcon from '@mui/icons-material/Dining';
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags';
import EngineeringIcon from '@mui/icons-material/Engineering';
import EscalatorIcon from '@mui/icons-material/Escalator';
import FactoryIcon from '@mui/icons-material/Factory';
import RadioIcon from '@mui/icons-material/Radio';
import SecurityIcon from '@mui/icons-material/Security';
import CameraIndoorIcon from '@mui/icons-material/CameraIndoor';
import CameraOutdoorIcon from '@mui/icons-material/CameraOutdoor';
import CatchingPokemonIcon from '@mui/icons-material/CatchingPokemon';
import CleanHandsIcon from '@mui/icons-material/CleanHands';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import FireplaceIcon from '@mui/icons-material/Fireplace';
import GarageIcon from '@mui/icons-material/Garage';
import HandymanIcon from '@mui/icons-material/Handyman';
import HardwareIcon from '@mui/icons-material/Hardware';
import HealingIcon from '@mui/icons-material/Healing';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import HeartBrokenIcon from '@mui/icons-material/HeartBroken';
import HeatPumpIcon from '@mui/icons-material/HeatPump';
import HubIcon from '@mui/icons-material/Hub';

export const inventoryCategoryIconMap = {
  'fire-extinguisher': FireExtinguisherIcon,
  'medical-services': MedicalServicesIcon,
  'monitor-heart': MonitorHeartIcon,
  battery: Battery5BarIcon,
  'blind-assistance': BlindIcon,
  'assist-walker': AssistWalkIcon,
  computer: ComputerIcon,
  headphones: HeadphonesIcon,
  'tablet-mac': TabletMacIcon,
  router: RouterIcon,
  crib: CribIcon,
  'coffee-maker': CoffeeMakerIcon,
  dining: DiningIcon,
  'emoji-flags': EmojiFlagsIcon,
  engineering: EngineeringIcon,
  escalator: EscalatorIcon,
  factory: FactoryIcon,
  radio: RadioIcon,
  security: SecurityIcon,
  'camera-indoor': CameraIndoorIcon,
  'camera-outdoor': CameraOutdoorIcon,
  'catching-pokemon': CatchingPokemonIcon,
  'clean-hands': CleanHandsIcon,
  'electric-bolt': ElectricBoltIcon,
  fireplace: FireplaceIcon,
  garage: GarageIcon,
  handyman: HandymanIcon,
  hardware: HardwareIcon,
  healing: HealingIcon,
  'health-and-safety': HealthAndSafetyIcon,
  'heart-broken': HeartBrokenIcon,
  'heat-pump': HeatPumpIcon,
  hub: HubIcon,
  'smart-screen': SmartScreenIcon,
} satisfies Record<string, typeof SvgIcon>;

export type InventoryCategoryIconName = keyof typeof inventoryCategoryIconMap;
